import React from "react";
import ReactDOM from "react-dom/client";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja, ko } from "date-fns/locale";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "./theme/theme";
import LanguageSync from "./LanguageSync";
import "./i18n";
import { getBaseLanguage } from "./utils/utilities";

if (process.env.REACT_APP_MODE === "production") {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
}

const baseLanguage = getBaseLanguage();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={
        baseLanguage === "ja" ? ja : baseLanguage === "ko" ? ko : ""
      }
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Provider store={store}>
          <LanguageSync>
            <App />
          </LanguageSync>
        </Provider>
      </ThemeProvider>
    </LocalizationProvider>
  </React.StrictMode>,
);
